var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup308(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.047,
    height: 34.048,
    viewBox: "0 0 34.047 34.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(-73.25 -374.013)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_51_",
    x1: 8.924,
    y1: 8.924,
    transform: "translate(91.236 377.599)",
    fill: "none",
    stroke: "#329bc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_50_",
    x2: 8.924,
    y2: 8.924,
    transform: "translate(85.602 383.234)",
    fill: "none",
    stroke: "#329bc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_450_",
    d: "M145.349,18.471l5.636-5.636a1.661,1.661,0,0,0,0-2.348h0a1.661,1.661,0,0,0-2.348,0L143,16.122a1.661,1.661,0,0,0,0,2.348h0A1.661,1.661,0,0,0,145.349,18.471Z",
    transform: "translate(-59.746 364.764)",
    fill: "none",
    stroke: "#329bc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_449_",
    d: "M315.747,188.869l5.636-5.636a1.661,1.661,0,0,0,0-2.348h0a1.661,1.661,0,0,0-2.349,0L313.4,186.52a1.661,1.661,0,0,0,0,2.348h0A1.661,1.661,0,0,0,315.747,188.869Z",
    transform: "translate(-218.873 205.638)",
    fill: "none",
    stroke: "#329bc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_447_",
    d: "M207.947,171.618h0l-5.167-5.167h0a2.657,2.657,0,0,0,0,3.758l1.409,1.409A2.657,2.657,0,0,0,207.947,171.618Z",
    transform: "translate(-115.301 218.662)",
    fill: "none",
    stroke: "#329bc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_446_",
    d: "M23.255,219.374,10.612,231.189a1.924,1.924,0,1,0,2.671,2.768l.048-.05,11.815-12.642",
    transform: "translate(64 169.24)",
    fill: "none",
    stroke: "#329bc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_445_",
    x1: 2.65,
    y1: 2.65,
    transform: "translate(75.586 399.522)",
    fill: "none",
    stroke: "#329bc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_444_",
    d: "M230.9,455.117h17.935v-1.337a1.985,1.985,0,0,0-1.985-1.985H232.883a1.985,1.985,0,0,0-1.985,1.985Z",
    transform: "translate(-142.285 -47.806)",
    fill: "none",
    stroke: "#329bc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    d: "M283.682,404.913v-1.337a1.985,1.985,0,0,0-1.985-1.985h-8.651a1.985,1.985,0,0,0-1.985,1.985v1.337",
    transform: "translate(-179.791 -0.923)",
    fill: "none",
    stroke: "#329bc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup308);
export default __webpack_public_path__ + "static/media/Group 308.858e5fcf63ab1856ebbda7dae40a497b.svg";
export { ForwardRef as ReactComponent };